const PrivacyPolicy = () => {
    return (
        <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
            <h1>Privacy Policy</h1>
            <h2>Effective Date: July 11, 2025</h2>

            <p>
                Welcome to our website. This Privacy Policy outlines how we handle your personal information, data collection practices, advertising partnerships, and disclaimers. By using this website, you acknowledge and agree to the terms outlined in this policy.
            </p>

            <h2>Information We Collect</h2>
            <p>
                We currently do not directly collect any personally identifiable information (PII) such as your name, email address, contact information, or game scores. Our website does not have any login system, user account infrastructure, or backend data storage mechanism that would allow us to collect or retain user-specific data.
            </p>

            <h2>Use of Third-Party Services</h2>
            <p>
                While we do not collect data ourselves, we utilize third-party services such as Google AdSense to deliver advertisements. These third-party advertisers may automatically collect certain information about your visit to this website through cookies and similar tracking technologies.
            </p>

            <p>These services may collect the following information:</p>
            <ul>
                <li><strong>Cookies:</strong> Small files stored on your browser to help remember your preferences or activity.</li>
                <li><strong>IP Address:</strong> Used to approximate your general location.</li>
                <li><strong>Device and Browser Information:</strong> Includes your operating system, browser type, and version.</li>
                <li><strong>Browsing Activity:</strong> Interaction with our site and other websites you visit may be tracked.</li>
                <li><strong>Location Data:</strong> General location inferred from your IP address.</li>
            </ul>

            <p>
                These practices are governed by the privacy policies of the third-party service providers. We do not have access to or control over the data collected by these third parties.
            </p>

            <h2>Is This Website Safe?</h2>
            <p>
                This website is intended solely for educational and demonstrative purposes. It does not contain any known malicious code, unsafe materials, or intentionally harmful content. However, we cannot guarantee that the website is completely free of vulnerabilities, bugs, or external threats beyond our control. Users are encouraged to use their discretion and take appropriate precautions.
            </p>

            <h2>Disclaimer and Limitation of Liability</h2>
            <p>
                BY ACCESSING OR USING THIS WEBSITE, YOU AGREE THAT YOU DO SO VOLUNTARILY AND AT YOUR OWN RISK. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
            </p>

            <p>
                UNDER NO CIRCUMSTANCES SHALL WE BE HELD LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, OR EXEMPLARY DAMAGES ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THIS WEBSITE OR RELIANCE ON ANY INFORMATION PROVIDED HEREIN, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            </p>

            <h2>Third-Party Links</h2>
            <p>
                Our website may contain links to other websites operated by third parties. We are not responsible for the privacy practices or the content of those websites. You access such third-party websites at your own risk.
            </p>

            <h2>Children's Privacy</h2>
            <p>
                This website is not intended for use by individuals under the age of 13. We do not knowingly collect data from children. If you believe a child has provided us with personal information, please contact us immediately so we can delete the data.
            </p>

            <h2>Policy Changes</h2>
            <p>
                We reserve the right to modify this Privacy Policy at any time without prior notice. Changes will take effect immediately upon being posted on this page. Your continued use of the website constitutes acceptance of any revisions.
            </p>

            <div style={{ marginTop: '20px' }}>
                <p>
                    For more information about how our advertising partners handle your data, please refer to their respective privacy policies (e.g., Google AdSense: https://policies.google.com/technologies/ads).
                </p>
                <p>
                    If you have any questions or concerns about this Privacy Policy, you may contact us at your discretion, but we are under no obligation to respond or take action.
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
